module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-google-gtag/gatsby-browser.js'),
      options: {"plugins":[],"trackingIds":[null]},
    },{
      plugin: require('../node_modules/@sentry/gatsby/gatsby-browser.js'),
      options: {"plugins":[],"dsn":"https://96c9a530cd4c411fae8ef8d41b129aba@o524538.ingest.sentry.io/5644618","sampleRate":0.5},
    }]
